import SignIn from './SignIn.view';

export default SignIn;
